import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Field } from "@/pages/Login";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { setToken(params.get("token") || ""); }, [params]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Mínimo 8 caracteres.");
    if (password !== confirm) return setError("As senhas não coincidem.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Senha redefinida! Pode entrar agora.");
      nav("/login");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md card-soft p-8">
        <h1 className="text-2xl font-extrabold text-[#243B53] text-center">Redefinir senha</h1>
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          {!token && (
            <Field as="textarea" label="Token" value={token} onChange={setToken} testid="reset-token-input" rows={3} />
          )}
          <Field label="Nova senha" type="password" value={password} onChange={setPassword} testid="reset-password-input" />
          <Field label="Confirmar nova senha" type="password" value={confirm} onChange={setConfirm} testid="reset-confirm-input" />
          {error && <div data-testid="reset-error" className="text-sm text-red-600 font-bold">{error}</div>}
          <button data-testid="reset-submit-btn" disabled={loading || !token} className="btn-primary w-full">
            {loading ? "Salvando…" : "Redefinir senha"}
          </button>
        </form>
      </div>
    </div>
  );
}
